/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { EuiSpacer, EuiTitle } from "@elastic/eui";
import { updateTripPrices } from "modules/trips/api";
import SectionsCard from "../shared/tripReconiliation/SectionsCard";
import ExpensesFields from "../shared/tripReconiliation/ExpensesFields";
import { TripPiceBox } from "./style";

const OperationalExpenses = ({ tripId, tripPrices, setIsPricesChanged, isPricesChanged }) => {
    const intl = useIntl();
    const [expenseTotals, setExpenseTotals] = useState({});
    const [switchStates, setSwitchStates] = useState({});
    const [isSaved, setIsSaved] = useState(true);

    const expenseItems = useMemo(
        () => [
            {
                id: 1,
                key: "tolls",
                label: <FormattedMessage id="trip.reconciliation.operational.tolls" />,
                showPrice: true,
                showNotes: true,
                prepend: <FormattedMessage id="egp" />,
                expenseValue: tripPrices?.tolls,
            },
            {
                id: 2,
                key: "scales",
                label: <FormattedMessage id="trip.reconciliation.operational.scales" />,
                showPrice: true,
                showNotes: true,
                prepend: <FormattedMessage id="egp" />,
                expenseValue: tripPrices?.scales,
            },
            {
                id: 3,
                key: "customs",
                label: <FormattedMessage id="trip.reconciliation.operational.customs" />,
                showPrice: true,
                showNotes: true,
                prepend: <FormattedMessage id="egp" />,
                expenseValue: tripPrices?.customs,
            },
            {
                id: 4,
                key: "others",
                label: <FormattedMessage id="trip.reconciliation.operational.others" />,
                showPrice: true,
                showNotes: true,
                prepend: <FormattedMessage id="egp" />,
                expenseValue: tripPrices?.others,
            },
        ],
        [intl.locale, tripPrices]
    );
    // Handler to update totals for each expense item
    const handleTotalChange = useCallback((id, { price, notes }) => {
        setExpenseTotals((prevTotals) => ({
            ...prevTotals,
            [id]: { price, notes },
        }));
    }, []);

    // Calculate the overall total
    const calculateTotalExpenses = useMemo(
        () =>
            expenseItems.reduce((sum, item) => {
                const expense = expenseTotals[item.id] || {};
                const total = expense.price || 0;
                const isSwitchOn = switchStates[item.id] || false;
                // Subtract total if the item is marked as deduction
                return isSwitchOn ? sum + total : sum;
            }, 0),
        [expenseItems, expenseTotals]
    );

    // // Prepare the payload for the backend
    // const preparePayload = () => {
    //     const payload = expenseItems.reduce((result, item) => {
    //         const expense = expenseTotals[item.id] || {};
    //         const isSwitchOn = switchStates[item.id];
    //         if (isSwitchOn && (expense.price || expense.notes)) {
    //             result[item.key] = {
    //                 price: expense.price || 0,
    //                 ...(expense.notes && { notes: expense.notes }),
    //             };
    //         }
    //         return result;
    //     }, {});
    //     return { trip_price: payload };
    // };

    const preparePayload = () => {
        const payload = expenseItems.reduce((result, item) => {
            const expense = expenseTotals[item.id] || {};
            result[item.key] = {
                price: expense.price || 0,
                ...(expense.notes && { notes: expense.notes }),
            };

            return result;
        }, {});
        return { trip_price: payload };
    };

    // Mock API call
    const handleSubmit = () => {
        const payload = preparePayload();
        updateTripPrices(tripId, payload).then(() => {
            setIsSaved(true);
            setIsPricesChanged(!isPricesChanged);
        });
    };
    const handleSwitchChange = (id, isOn) => {
        setSwitchStates((prevStates) => ({
            ...prevStates,
            [id]: isOn,
        }));
    };
    return (
        <SectionsCard
            showButton
            title={<FormattedMessage id="trip.reconciliation.operational.title" />}
            onButtonClick={handleSubmit}
            isButtonDisabled={isSaved}
        >
            <TripPiceBox>
                <h4>
                    {" "}
                    <FormattedMessage id="trip.reconciliation.operational.total" />
                </h4>
                <EuiTitle size="s">
                    <p>{calculateTotalExpenses}</p>
                </EuiTitle>
            </TripPiceBox>
            <EuiSpacer size="m" />
            {expenseItems.map((item) => (
                <ExpensesFields
                    key={item.id}
                    label={item.label}
                    showNotes={item.showNotes}
                    showPrice={item.showPrice}
                    append={item.prepend}
                    onTotalChange={handleTotalChange}
                    expenseValue={item.expenseValue}
                    id={item?.id}
                    onSwitchChange={handleSwitchChange}
                    isSwitchOn={switchStates[item.id] || false}
                    setIsSaved={setIsSaved}
                />
            ))}
        </SectionsCard>
    );
};

export default OperationalExpenses;
